export const trackAddToCart = (props) => {
  if (props.quantity > 0 && ADDWISH_PARTNER_NS !== undefined) {
    let total = props.cartTotalTracking;
    let cartObject = {
      total: total,
    };
    let urlsCombined = [];
    props.orderRows.map(item =>  urlsCombined.push(item.helloRetailTrackingUrl));
    cartObject["urls"] = urlsCombined;

    ADDWISH_PARTNER_NS.api.cart.setCart(cartObject);
  }
}

export const trackSale = (props) => {
  if (ADDWISH_PARTNER_NS !== undefined) {
    const order = JSON.parse(props)
    const total = order.orderTotalTracking;
    const email = order.emailTracking;
    const orderNumber = order.externalOrderID;  
  
    let orderObject = {
      total: total,
      orderNumber: orderNumber,
      email: email,      
    };
    let urlsCombined = [];
  
    order.orderRows.map(item => urlsCombined.push(item.helloRetailTrackingUrl));  
    orderObject["urls"] = urlsCombined;
  
    _awev = (window._awev || []); _awev.push(["bind_once", "context_ready", function () {
      ADDWISH_PARTNER_NS.api.conversion.track_sale(orderObject);
    }]);
  }  
}